
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","version":"1.1","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clippath"}},[_c('path',{attrs:{"stroke-width":"0","fill":"none","d":"M0 0h16v16H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#clippath)"}},[_c('path',{staticClass:"cls-3",attrs:{"d":"M5 13.6c-.2 0-.3 0-.4-.2l-2-2c-.2-.2-.2-.6 0-.9s.6-.2.9 0l1.6 1.6 1.6-1.6c.2-.2.6-.2.9 0s.2.6 0 .9l-2 2c-.1.1-.3.2-.4.2z"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M5 13.6c-.3 0-.6-.3-.6-.6V3c0-.3.3-.6.6-.6s.6.3.6.6v10c0 .3-.3.6-.6.6zM13 5.6c-.2 0-.3 0-.4-.2L11 3.8 9.4 5.4c-.2.2-.6.2-.9 0s-.2-.6 0-.9l2-2c.2-.2.6-.2.9 0l2 2c.2.2.2.6 0 .9-.1.1-.3.2-.4.2z"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M11 13.6c-.3 0-.6-.3-.6-.6V3c0-.3.3-.6.6-.6s.6.3.6.6v10c0 .3-.3.6-.6.6z"}})])])
          )
        }
      }
    